<div class="container" *ngIf="pdfSrc">
  <h4 class="fw-bold">{{ data.pdf.fileDescription }}</h4>
  <ngx-extended-pdf-viewer
    [src]="pdfSrc"
    [useBrowserLocale]="true"
  ></ngx-extended-pdf-viewer>
</div>
